// extracted by mini-css-extract-plugin
export var button = "_fe-4";
export var hasDarkBackground = "_fe-7";
export var hasLightBackground = "_fe-6";
export var iconWrapper = "_fe-0";
export var large = "_fe-2";
export var medium = "_fe-1";
export var small = "_fe-5";
export var xsmall = "_fe-3";